const initialState = {
  data: null,
  loading: false,
  error: false,
};

export function comparisonAnalytics(state = initialState, action) {
  switch (action.type) {
    case "COMPARISON_ANALYTICS_FETCH_DATA_SUCCESS":
      return { ...state, data: action.data, error: false };
    default:
      return state;
  }
}
